import { render } from "./ForgotPassword.vue?vue&type=template&id=32493803&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=32493803&scoped=true&lang=css"
import "./ForgotPassword.vue?vue&type=style&index=1&id=32493803&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32493803"]])

export default __exports__